import { subYears } from 'date-fns'
import { TFunction } from 'i18next'

import { schemas, yup } from '@app/schemas'
import { requiredMsg } from '@app/util'
import { Organization } from '@app/generated/graphql'

export type CompleteProfileFormInputs = {
  firstName: string
  familyName: string
  country: string
  countryCode: string
  phone: string
  phoneCountryCode: string
  dob: Date | null
  tcs: boolean
  jobTitle: string
  otherJobTitle: string
  organization?: Pick<Organization, 'name' | 'urn'> &
    Partial<Pick<Organization, 'id'>>
}

export const getCompleteProfileFormSchema = (t: TFunction) => {
  return yup.object({
    firstName: yup.string().required(requiredMsg(t, 'first-name')),

    familyName: yup.string().required(requiredMsg(t, 'surname')),

    phone: schemas.phone(t),

    phoneCountryCode: yup.string().optional(),

    country: yup.string().required(),

    countryCode: yup.string().required(),

    dob: yup
      .date()
      .typeError(t('validation-errors.invalid-date'))
      .required(t('validation-errors.date-required'))
      .max(subYears(new Date(), 16), t('validation-errors.date-too-early')),

    tcs: yup.boolean().oneOf([true], t('pages.complete-profile.tcs-required')),

    jobTitle: yup.string().required(requiredMsg(t, 'job-title')),

    otherJobTitle: yup.string().when('jobTitle', ([jobTitle], schema) => {
      return jobTitle === 'Other'
        ? schema.required(t('validation-errors.other-job-title-required'))
        : schema
    }),

    organization: yup
      .object({
        id: yup.string().required(),
      })
      .required(t('components.course-form.organisation-required')),
  })
}
